import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import ForbiddenImg from 'assets/img/errors/403-error-forbidden.svg';
import ErrorDetailPanel from './ErrorDetailPanel';

// Phần thân của màn hình 403, dùng chung cho:
//  - route /errors/403 (Error403)
//  - overlay bung ra ngay trong MainLayout khi một request đọc dữ liệu bị 403
//    (GlobalAccessDeniedOverlay)
// Tách ra để hai nơi luôn hiển thị giống hệt nhau.
const AccessDeniedPanel = ({ description, onRetry }) => {
  const navigate = useNavigate();

  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-text-center tw-px-4 tw-w-full tw-max-w-2xl">
      {/* Image */}
      <div className="tw-mb-4 tw-w-full tw-max-w-xs">
        <img src={ForbiddenImg} alt="403 Forbidden" className="tw-w-full tw-h-auto tw-object-contain" />
      </div>

      {/* Code */}
      <h1 className="tw-text-5xl tw-font-bold tw-text-red-600 tw-mb-1">403</h1>

      {/* Title */}
      <h2 className="tw-text-2xl tw-font-bold tw-text-gray-800 tw-mb-3">Unauthorized Access</h2>

      <p className="tw-text-sm tw-text-gray-600 tw-mb-6 tw-leading-relaxed tw-max-w-md">{description}</p>

      {/* Actions */}
      <div className="tw-flex tw-flex-col tw-gap-2 tw-w-full tw-max-w-xs tw-mb-4">
        {onRetry && (
          <button
            onClick={onRetry}
            className="tw-w-full tw-px-6 tw-py-2.5 tw-text-sm tw-bg-gray-100 tw-text-gray-700 tw-font-semibold tw-rounded hover:tw-bg-gray-200 tw-transition tw-border-0 tw-cursor-pointer"
          >
            ← Go Back
          </button>
        )}
        <button
          onClick={() => navigate('/')}
          className="tw-w-full tw-px-6 tw-py-2.5 tw-text-sm tw-bg-blue-600 tw-text-white tw-font-semibold tw-rounded hover:tw-bg-blue-700 tw-transition tw-border-0 tw-cursor-pointer"
        >
          🏠 Take me Home
        </button>
        <a
          href="mailto:portal@pebsteel.com.vn"
          className="tw-w-full tw-px-6 tw-py-2.5 tw-text-sm tw-bg-gray-100 tw-text-gray-700 tw-font-semibold tw-rounded hover:tw-bg-gray-200 tw-transition tw-text-center"
        >
          📧 Contact IT Department
        </a>
      </div>

      {/* Diagnostic panel */}
      <ErrorDetailPanel />
    </div>
  );
};

AccessDeniedPanel.propTypes = {
  description: PropTypes.string,
  onRetry:     PropTypes.func,
};

AccessDeniedPanel.defaultProps = {
  description: 'You do not have permission to access this resource. Contact your administrator if you think this is a mistake.',
  onRetry:     null,
};

export default AccessDeniedPanel;
